
import { Component, Vue, Prop, Watch } from "vue-property-decorator"

import TimeDurationPicker from "./CaseDetails/Users/TimeDurationPicker.vue"

import { TimeEntry as TimeEntryType, TimeEntryInputFormat } from "@/types/timeEntry"

@Component({
	components: {
		"time-duration-picker": TimeDurationPicker
	}
})
export default class TimeEntry extends Vue {
	/* --- Props --- */

    @Prop({ type: Object, required: true })
    value!: TimeEntryType

	@Prop({ type: String, default: TimeEntryInputFormat.Decimal })
    inputFormat!: TimeEntryInputFormat

	@Prop({ type: Boolean, default: false })
    isReadonly!: boolean

	/* --- Data --- */

	TimeEntryInputFormat = TimeEntryInputFormat

	timeEntry: TimeEntryType = this.value

	/* --- Watchers --- */

	@Watch("value", { immediate: true, deep: true })
	onTimeEntryChange (newVal: TimeEntryType) {
		this.timeEntry = newVal
	}

	/* --- Methods --- */

	private remove () {
		this.$emit("remove", this.timeEntry.id)
	}

	private update () {
		this.$emit("input", { ...this.timeEntry })
	}
}
